/**
 * @module landing
 * @description Landing-page (Index) port-input form behavior.
 *
 * Validates the entered port (1–65535 integer) and navigates to /host?port=…
 * on submit. Built into /js/landing.js by scripts/build-client.js.
 */
export {};

const form = document.getElementById('landing-form') as HTMLFormElement | null;
const portInput = document.getElementById('landing-port') as HTMLInputElement | null;
const errorEl = document.getElementById('landing-error') as HTMLElement | null;

if (form && portInput && errorEl) {
  form.addEventListener('submit', () => {
    const val = portInput.value.trim();
    const n = Number(val);
    if (!val || !Number.isInteger(n) || n < 1 || n > 65535) {
      errorEl.textContent = 'Please enter a port number between 1 and 65535.';
      errorEl.style.display = 'block';
      portInput.focus();
      return;
    }
    errorEl.style.display = 'none';
    window.location.href = '/host?port=' + encodeURIComponent(val);
  });

  portInput.addEventListener('input', () => {
    errorEl.style.display = 'none';
  });
}
